<template>
  <div>
    <loading v-if="load" :fullscrean="true"/>
    <top-bar title="QrCode" v-show="!load"/>
    <div class="container" style="max-width: 512px" v-show="!load">
      <div style="padding-bottom: 32px">
        <div class="card bg-white p-3 shadow-sm">
          <form @submit.prevent="validarSacola" v-if="ativado">
            <h6 class="font-weight-bold text-center mb-3">Escolha uma opção</h6>
            <div class="mb-3">
              <div id="tipoPedido" class="row no-gutters">
                <div class="col-6 pr-1">
                  <a href="javascript:" class="card card-border text-center pointer card-pedido" :class="{'selected': nolocal.tipo_pedido === '3'}" @click="selecionarTipo('3')">
                    <icon name="local" size="24"></icon>
                    <div class="mt-2 small">Consumir no local</div>
                  </a>
                </div>
                <div class="col-6 pl-1">
                  <a href="javascript:" class="card card-border text-center pointer card-pedido" :class="{'selected': nolocal.tipo_pedido === '2'}" @click="selecionarTipo('2')">
                    <icon name="viagem" size="24"></icon>
                    <div class="mt-2 small">Para levar</div>
                  </a>
                </div>
              </div>
            </div>
            <div class="form-group mb-2">
              <label for="ondeEstou" class="font-weight-bold m-0 small">Onde você está?</label>
              <select id="ondeEstou" class="form-control" v-model="nolocal.onde_estou" @change="nolocal.obs_pedido = ''">
                <option value="Mesa">Mesa</option>
                <option value="Balcão">Balcão</option>
                <option value="Drive-thru">Drive-thru</option>
              </select>
            </div>
            <div class="form-group" v-if="nolocal.onde_estou === 'Mesa'">
              <label for="mesa" class="font-weight-bold m-0 small">Número da mesa</label>
              <input id="mesa" type="number" class="form-control" v-model="nolocal.obs_pedido" placeholder="Ex: 12" required>
            </div>
            <div class="form-group" v-if="nolocal.onde_estou === 'Drive-thru'">
              <div>
                <label for="driveThru" class="font-weight-bold m-0 small">Descreva seu automóvel <span class="pl-1 small text-muted">{{nolocal.obs_pedido.length}} de 20</span></label>
                <input id="driveThru" type="text" class="form-control" v-model="nolocal.obs_pedido" maxlength="20" placeholder="Ex: Uno Mille Cinza (ABC-1234)">
              </div>
              <div class="small">* Modelo, cor ou a placa do seu carro</div>
            </div>
            <div class="mt-4">
              <button class="btn btn-primary btn-block">Continuar</button>
            </div>
          </form>
          <div v-else>
            <h6 class="font-weight-bold text-center mb-3">Pedido no Local</h6>
            <aviso-informativo variante="amarelo" class="small mb-3">
              <div>Os pedido no local estão desativados no momento, clique em continuar para voltar para a tela inicial.</div>
            </aviso-informativo>
            <div>
              <button class="btn btn-primary btn-block" @click="goHome()">Continuar</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AvisoInformativo from "../components/AvisoInformativo";
  import TopBar from "../components/TopBar";
  import Icon from "../components/Icon";
  import Loading from "../components/Loading";

  export default {
    name: 'NoLocal',
    components: {AvisoInformativo, Loading, Icon, TopBar},
    data() {
      return {
        load: false,
        ativado: true,
        nolocal: {
          tipo_pedido: '3',
          onde_estou: 'Mesa',
          obs_pedido: '',
          expiracao: ''
        }
      }
    },

    methods: {
      selecionarTipo(val) {
        this.nolocal.tipo_pedido = val;
        this.nolocal.obs_pedido = '';
      },

      validarUrl() {
        if (!this.ativado) {
          return;
        }

        const url = new URLSearchParams(window.location.search);
        const id = url.get('id') ? url.get('id').toLowerCase() : '';
        let mesa = url.get('mesa') ? url.get('mesa').replace(/[^0-9]/g, '') : null;
        let comanda = url.get('comanda') ? url.get('comanda').replace(/[^0-9]/g, '') : null;

        if (mesa || comanda || id.startsWith('mesa') || id.startsWith('balcão') || id.startsWith('balcao') || id.startsWith('drive-thru')) {
          if (!id.startsWith('drive-thru')) {
            mesa = id ? id.replace(/[^0-9]/g, '') : mesa;
            this.nolocal.tipo_pedido = '3';
            this.nolocal.onde_estou = (mesa || id.startsWith('mesa')) ? 'Mesa' : (comanda ? 'Comanda' : 'Balcão');

            if (this.nolocal.onde_estou === 'Balcão') {
              this.createSacola();

            } else if (mesa || comanda) {
              this.nolocal.obs_pedido = (mesa || comanda);
              this.createSacola();
            }

          } else {
            this.nolocal.tipo_pedido = '2';
            this.nolocal.onde_estou = 'Drive-thru';
            this.$helpers.focusrElement('driveThru');
          }
        }
      },

      validarSacola() {
        let obs_pedido = "";

        switch (this.nolocal.onde_estou) {
          case 'Drive-thru':
            obs_pedido = this.nolocal.obs_pedido ? this.nolocal.obs_pedido.substr(0, 20) : "";
            break;

          case 'Balcão':
            obs_pedido = '';
            break;

          case 'Mesa':
            if (!this.nolocal.obs_pedido || isNaN(this.nolocal.obs_pedido) || this.nolocal.obs_pedido <= 0 || this.nolocal.obs_pedido > 10000) {
              this.$swal("Por favor informe um número válido para a mesa!").then(() => {
                this.$helpers.focusrElement('mesa');
              });

              return;
            }

            obs_pedido = this.nolocal.obs_pedido;
            break;
        }

        this.nolocal.obs_pedido = obs_pedido
        this.createSacola();
      },

      createSacola() {
        this.nolocal.expiracao = new Date().getTime() + ((1000 * 60 * 60) * 8);

        if (this.sacola && this.sacola.token === this.empresa.token) {
          this.$store.state.sacola.expiracao = this.nolocal.expiracao;
          this.$store.state.sacola.tipo_pedido = this.nolocal.tipo_pedido;
          this.$store.state.sacola.nolocal = '';
          this.$store.state.sacola.id_pagamento = '5';
          this.$store.state.sacola.id_cupom = null;
          this.$store.state.sacola.cupom = {};
          this.$store.state.sacola.origin = '4';

        } else {
          this.$store.state.sacola = {
            token: this.empresa.token,
            expiracao: this.nolocal.expiracao,
            tipo_pedido: this.nolocal.tipo_pedido,
            cliente: {},
            id_pagamento: '1',
            produtos: [],
            valor_frete: 0,
            total: 0,
            origin: '4',
            obs_pedido: '',
            nolocal: ''
          }
        }

        this.$store.state.nolocal = this.nolocal;
        localStorage.setItem('nolocal', JSON.stringify(this.nolocal));
        localStorage.setItem('sacola', JSON.stringify(this.$store.state.sacola));

        this.load = true;
        this.$helpers.getCardapioEmpresa(this, this.empresa.token, this.nolocal.tipo_pedido, (res) => {
          this.load = false;

          if (res) {
            this.goHome();
            this.$swal('Você está pedindo no local');
          }
        });
      },

      goHome() {
        const url = this.$helpers.getUrlApp(this.$route.params.id || '') + '/';
        this.$router.push(url);
      }
    },

    mounted() {
      if (!this.empresa.id_empresa) {
        sessionStorage.setItem('redirect', this.$route.fullPath);
        this.$router.push('/');
        return;
      }

      this.ativado = this.empresa?.json_config?.nolocal || false;
      this.validarUrl()
    },

    computed: {
      empresa() {
        return this.$store.state.empresa
      },

      sacola() {
        return this.$store.state.sacola
      }
    }
  }
</script>

<style scoped>
  .card-pedido {
    height: 86px;
    display: flex;
    justify-content: center;
    color: var(--dark);
  }
  .card-pedido.selected {
    border: 2px solid var(--lecard-primary);
    color: var(--lecard-primary);
  }
</style>
